import { Component, ElementRef, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MvPoleService } from 'shared-lib';
import { SubstationService } from 'shared-lib';

@Component({
  selector: 'app-audit-review',
  templateUrl: './audit-review.component.html',
  styleUrl: './audit-review.component.scss',
  standalone: false,
})
export class AuditReviewComponent {
  @ViewChild('closeModal') closeModal!: ElementRef;
  @Input() areaId!: number;
  @Input() assetType!: string;
  @Input() assetId!: number;

  constructor(
    private mvPoleService: MvPoleService,
    private substationService: SubstationService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  submitAudit() {
    switch (this.assetType) {
      // case 'Customer': {
      //   this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Field Audit', {
      //     customer_id: this.assetId,
      //   });
      //   this.customerService.auditCustomer(this.assetId).subscribe({
      //     next: (response) => {
      //       const responseData = response.body;
      //       if (responseData?.status === 200 || responseData?.status === 'OK') {
      //         this.toastr.success('Successfully audited customer.');
      //         this.closeModal.emit(responseData.data);
      //       } else {
      //         this.toastr.error(responseData?.message);
      //       }
      //     },
      //     error: (_) => {
      //       this.toastr.error('Error occured.');
      //     },
      //   });
      //   break;
      // }
      // case 'Building': {
      //   this.analyticsService.logCustomEvent('BUILDINGS DETAILS: Field Audit', {
      //     customer_id: this.assetId,
      //   });
      //   this.buildingService.auditBuilding(this.assetId).subscribe({
      //     next: (response) => {
      //       const responseData = response.body;
      //       if (responseData?.status === 200 || responseData?.status === 'OK') {
      //         this.toastr.success('Successfully audited building.');
      //         this.closeModal.emit(responseData.data);
      //         this.handleReturn();
      //       } else {
      //         this.toastr.error(responseData?.message);
      //       }
      //     },
      //     error: (_) => {
      //       this.toastr.error('Error occured.');
      //     },
      //   });
      //   break;
      // }
      // case 'Pole': {
      //   this.analyticsService.logCustomEvent('POLES DETAILS: Field Audit', {
      //     customer_id: this.assetId,
      //   });
      //   this.poleService.auditPole(this.assetId).subscribe({
      //     next: (response) => {
      //       const responseData = response.body;
      //       if (responseData?.status === 200 || responseData?.status === 'OK') {
      //         this.toastr.success('Successfully audited pole.');
      //         setTimeout(() => {
      //           window.location.reload();
      //         }, 500);
      //       } else {
      //         this.toastr.error(responseData?.message);
      //       }
      //     },
      //     error: (_) => {
      //       this.toastr.error('Error occured.');
      //     },
      //   });
      //   break;
      // }
      // case 'Dt': {
      //   this.analyticsService.logCustomEvent('DT DETAILS: Field Audit', {
      //     customer_id: this.assetId,
      //   });
      //   this.dtService.auditDt(this.assetId).subscribe({
      //     next: (response) => {
      //       const responseData = response.body;
      //       if (responseData?.status === 200 || responseData?.status === 'OK') {
      //         this.toastr.success('Successfully audited transformer.');
      //         setTimeout(() => {
      //           window.location.reload();
      //         }, 500);
      //       } else {
      //         this.toastr.error(responseData?.message);
      //       }
      //     },
      //     error: (_) => {
      //       this.toastr.error('Error occured.');
      //     },
      //   });
      //   break;
      // }
      // case 'RMU' : {
      //   this.rmuService.auditrmu(this.assetId).subscribe({
      //     next: (response) => {
      //       const responseData = response.body;
      //       if (responseData?.status === 200 || responseData?.status === 'OK') {
      //         this.toastr.success('Successfully audited RMU.');
      //         setTimeout(() => {
      //           window.location.reload();
      //         }, 500);
      //       } else {
      //         this.toastr.error(responseData?.message);
      //       }
      //     },
      //     error: (_) => {
      //       this.toastr.error('Error occured.');
      //     },
      //   });
      //   break;

      // }
      case 'MvPole': {
        // this.analyticsService.logCustomEvent('POLES DETAILS: Field Audit', {
        //   customer_id: this.assetId,
        // });
        this.mvPoleService.auditMvPole(this.assetId).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully audited MV Pole.');
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }
      case 'Substation': {
        this.substationService.auditSubstation(this.assetId).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully audited Substation.');
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }

      default: {
        break;
      }
    }
  }
}
